module.exports = __webpack_public_path__ + "img/doctor_search_red_tc.007676dc.png";